<template>
  <div class="card home-demo flex-grow-1" id="card_duty" :key="searchMail">
    <!-- with next activicities -->
    <template
      v-if="filterRoster.length != 0 && isPersonExist && !isReturnNoDuty"
    >
      <div class="justify-content-end card-header justify-content-md-between">
        <div class="d-none d-md-block">
          Activities in 7 days:
          <span class="font-weight-bold">{{ showDutyLen }}</span>
          <span v-show="!originalMailOrNot" class="text-danger">
            <i class="fa fa-user-secret pl-3"></i>
            {{ searchMail.split("@")[0] }}
          </span>
        </div>
        <div class="card-tool">
          <button class="schedule-btn text-sm" @click="$router.push('/roster')">Roster</button>
        </div>
      </div>
      <div class="card-body d-flex" :class="actvType === 99 ? 'px-0' : 'px-4'">
        <div class="carousel-tit text-center">
          {{ ("" + showDutyName).toUpperCase() }}
        </div>
        <div v-if="actvType === 99">
          <img class="wonderImg" src="/img/Wonders.svg" alt />
          <img class="starImg" src="/img/Stars.svg" alt />
        </div>
        <div class="duty-info d-flex align-items-center owl-carousel owl-theme">
          <div
            v-for="({ subActv, actvType, remarks }, subActvIdx) in filterRoster"
            :key="subActvIdx"
          >
            <div v-if="filterSubActv(subActv).length > 1">
              <div
                v-for="(item, Idx) in filterSubActvList(subActvIdx)"
                :key="Idx"
              >
                <div
                  class="d-flex justify-content-center align-items-center mb-4 flight-select"
                >
                  <button
                    class="select-dropdown d-flex align-items-center justify-content-center position-relative"
                  >
                    <select
                      id="select"
                      v-model="selectedDuty"
                      @change="
                        onChangeMethod($event, $event.target.selectedIndex)
                      "
                    >
                      <option
                        v-for="(duty, dutyIdx) in filterSubActv(subActv)"
                        :key="dutyIdx"
                        :value="duty.subActvId"
                      >
                        {{ duty.subActvName }}
                      </option>
                    </select>
                    <button
                      class="position-absolute icon-position"
                      v-show="item.description"
                      v-b-popover.click.bottom="`${item.description}`"
                    >
                      <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                    </button>
                  </button>
                </div>
                <div v-show="item.subSignOnTz" class="brief">
                  <div class="briefContent">
                    <span class="tz-txt"
                      >REPORTING TIME{{ item.subStartTz }}</span
                    >
                    <div class="startTime">
                      {{ item.subSignOnDate }} {{ item.subSignOnTime }}
                    </div>
                  </div>
                </div>
                <div class="flight-info">
                  <div class="flight">
                    <div class="date">{{ item.subStartDate }}</div>
                    <div class="location">
                      <div class="title">{{ item.fromAirp }}</div>
                    </div>
                    <div class="time">
                      {{ item.subStartTime }} {{ item.subStartTz }}
                    </div>
                  </div>
                  <div class="duration">
                    <div class="line"></div>
                    <div class="plane">
                      <div
                        v-if="isAircReg(item.aircReg, item.position)"
                        class="icon-center d-flex justify-content-center align-items-center"
                      >
                        <span class="badge badge-secondary mr-2">{{
                          item.position
                        }}</span>
                        {{ item.aircReg }}
                      </div>
                      <div v-else class="nullHeight"></div>
                      <button
                        v-if="remarks"
                        v-b-popover.click.bottom.html="filterRemarks(remarks)"
                      >
                        <i :class="[showIcon, changeIconColor]"></i>
                      </button>
                      <span v-else><i :class="showIcon"></i></span>
                      <div class="time">
                        {{ durationFormat(item.duration) }}
                      </div>
                    </div>
                  </div>
                  <div class="flight">
                    <div class="date data-Right">{{ item.subEndDate }}</div>
                    <div class="location">
                      <div class="title">{{ item.toAirp }}</div>
                    </div>
                    <div class="time">
                      {{ item.subEndTime }} {{ item.subEndTz }}
                    </div>
                  </div>
                </div>
                <div
                  class="card-footer border-top-0 text-center mt-4"
                  v-show="showFooter"
                >
                  <a
                    class="btn btn-default"
                    href="#"
                    @click="crewListModalShow(actvType)"
                    >Crew List</a
                  >
                  <template v-if="actvType === 0">
                    <a
                      class="btn btn-default"
                      :class="{ disabled: !isHotelInfoValid }"
                      :href="`/#/d1folderdetail/hotel/${item.toAirp}`"
                      >Hotel Info.</a
                    >
                    <a
                      class="btn btn-default"
                      :href="`/#/d1folderdetail/airportInfo/${item.toAirp}`"
                      >Airport Info.</a
                    >
                  </template>
                </div>
              </div>
            </div>
            <template v-else>
              <div v-for="item in subActv" :key="item.dutySequence">
                <div
                  class="d-flex justify-content-center align-items-center"
                  :class="actvType === 99 ? 'mb-0' : 'mb-3'"
                >
                  <div class="singleTitle position-relative">
                    {{ subActv[0].subActvName }}
                    <button
                      class="single-icon-position position-absolute"
                      v-show="item.description"
                      v-b-popover.click.bottom="`${item.description}`"
                    >
                      <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div v-show="actvType != 99" class="brief">
                  <div class="briefContent">
                    <span class="tz-txt"
                      >REPORTING TIME{{ item.subStartTz }}</span
                    >
                    <div class="startTime">
                      {{ item.subSignOnDate }} {{ item.subSignOnTime }}
                    </div>
                  </div>
                </div>
                <div v-show="actvType != 99" class="flight-info">
                  <div class="flight">
                    <div class="date">{{ item.subStartDate }}</div>
                    <div class="location">
                      <div class="title">{{ item.fromAirp }}</div>
                    </div>
                    <div class="time">
                      {{ item.subStartTime }} {{ item.subStartTz }}
                    </div>
                  </div>
                  <div class="duration">
                    <div class="line"></div>
                    <div class="plane">
                      <div
                        v-if="isAircReg(item.aircReg, item.position)"
                        class="icon-center d-flex justify-content-center align-items-center"
                      >
                        <span class="badge badge-secondary mr-2">{{
                          item.position
                        }}</span>
                        {{ item.aircReg }}
                      </div>
                      <div v-else class="nullHeight"></div>
                      <button
                        v-if="remarks"
                        v-b-popover.click.bottom.html="filterRemarks(remarks)"
                      >
                        <i :class="[showIcon, changeIconColor]"></i>
                      </button>
                      <span v-else><i :class="showIcon"></i></span>
                      <div class="time">
                        {{ durationFormat(item.duration) }}
                      </div>
                    </div>
                  </div>
                  <div class="flight">
                    <div class="date data-Right">{{ item.subEndDate }}</div>
                    <div class="location">
                      <div class="title">{{ item.toAirp }}</div>
                    </div>
                    <div class="time">
                      {{ item.subEndTime }} {{ item.subEndTz }}
                    </div>
                  </div>
                </div>
                <div
                  class="card-footer border-top-0 text-center mt-4"
                  v-show="showFooter && actvType != 99"
                >
                  <a
                    class="btn btn-default"
                    href="#"
                    @click="crewListModalShow(actvType)"
                    >Crew List</a
                  >
                  <template v-if="actvType === 0">
                    <a
                      class="btn btn-default"
                      :href="'//sjx.lido.aero/lido/las/login.jsp'"
                      target="_blank"
                      >Flight Info.</a
                    >
                    <a
                      class="btn btn-default"
                      :class="{ disabled: !isHotelInfoValid }"
                      :href="`/#/d1folderdetail/hotel/${item.toAirp}`"
                      >Hotel Info.</a
                    >
                    <a
                      class="btn btn-default"
                      :href="`/#/d1folderdetail/airportInfo/${item.toAirp}`"
                      >Airport Info.</a
                    >
                  </template>
                </div>
                <!--happy birthday-->
                <Birthday v-if="actvType === 99" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>

    <!-- no activicities -->
    <template
      v-if="
        (filterRoster.length == 0 && isPersonExist) ||
          (filterRoster.length != 0 && isPersonExist && isReturnNoDuty)
      "
    >
      <div v-show="!originalMailOrNot">
        <div class="card-header">
          <div class="card-title">
            <span class="text-danger">
              <i class="fa fa-user-secret pl-3"></i>
              {{ searchMail.split("@")[0] }}
            </span>
          </div>
        </div>
      </div>
      <div class="card-body py-0">
        <div class="empty-status">
          <div class="icon"><i class="fa fa-plane text-muted"></i></div>
          <div class="title">No activities in next 7 days</div>
        </div>
      </div>
    </template>

    <!-- Crew email not found -->
    <template v-if="isPersonExist === false" class="col-12 d-flex">
      <div class="card-header">
        <div class="card-title">
          Crew email not found
          <span v-show="!originalMailOrNot" class="text-danger">
            <i class="fa fa-user-secret pl-3"></i>
            {{ searchMail.split("@")[0] }}
          </span>
        </div>
      </div>
      <div class="card-body py-0">
        <div class="empty-status">
          <div class="icon"><i class="icons icon-user-unfollow"></i></div>
          <div class="title">Crew email not found</div>
        </div>
      </div>
    </template>

    <CrewListModal
      v-if="crewListShow && byTrigger === 'byFlight'"
      :id="
        `${this.currentMission.subActvName + this.currentMission.subStartDate}`
      "
      @crewListModalClose="crewListModalClose"
      :currentMission="currentMission"
    >
    </CrewListModal>

    <GroundTrainingListModal
      v-if="crewListShow && byTrigger === 'byCourse'"
      @crewListModalClose="crewListModalClose"
      :currentMission="currentMission"
      :actvType="actvType"
    >
    </GroundTrainingListModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Birthday from "@/components/Birthday.vue";
import CrewListModal from "@/components/CrewListModal.vue";
import GroundTrainingListModal from "@/components/GroundTrainingListModal.vue";

export default {
  name: "NextActivity",
  components: {
    CrewListModal,
    GroundTrainingListModal,
    Birthday
  },
  data: () => ({
    selectedDuty: "",
    toggle: false,
    page: 0,
    titleArr: [],
    currentMission: {},
    crewListShow: false,
    byTrigger: "",
    actvType: 0,
    selectedIndex: 0,
    isRemark: true,
    searchMail: "",
    isHotelInfoValid: false
  }),
  methods: {
    ...mapActions(["getCrewRoster"]),
    async getCrewRosterData(mail) {
      this.searchMail = mail || "";
      const axiosData = {
        rosterStart: this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        rosterEnd: this.$moment()
          .utc()
          .add(7, "days")
          .format("YYYY-MM-DD HH:mm:ss")
      };
      if (this.searchMail) {
        axiosData.emplEmail = this.searchMail;
      }
      await this.getCrewRoster(axiosData);
      this.page = 0;
      this.changSelectedSubActv();
      this.filterTitleArr();
      this.owl();
    },
    async checkHotelInfoSatus(toAirp) {
      if (!toAirp) return false;
      return new Promise(async (resolve, reject) => {
        try {
          const res = await this.getPilotD2Folder(
            localStorage.getItem("access_token"),
            "hotel",
            toAirp
          );
          return res.data.value.length > 0 ? resolve(true) : resolve(false);
        } catch (error) {
          resolve(false);
        }
      });
    },
    async onChangeMethod(event, selectedIndex) {
      this.selectedIndex = selectedIndex;
      const currentActivity = this.filterRoster[this.page];
      if (this.actvType === 0) {
        const filter = currentActivity.subActv.filter(
          item => item.subActvName != "LO"
        );
        this.currentMission = filter[this.selectedIndex];
      } else {
        this.currentMission = currentActivity.subActv[this.selectedIndex];
      }

      const { toAirp } = this.currentMission;
      const bool = await this.checkHotelInfoSatus(toAirp);
      this.isHotelInfoValid = bool;
    },
    crewListModalShow(actvType) {
      if (actvType === 0) {
        this.byTrigger = "byFlight";
      } else {
        this.byTrigger = "byCourse";
      }
      this.crewListShow = true;
    },
    crewListModalClose(flightCrewListArr) {
      if (flightCrewListArr)
        flightCrewListArr.splice(0, flightCrewListArr.length);
      this.crewListShow = false;
    },
    owl() {
      const self = this;
      const owl = $(".owl-carousel");
      owl.owlCarousel({
        // animateOut: "fadeOut",
        items: 1,
        margin: 10,
        nav: true,
        dotClass: "dot",
        navContainerClass: "nav-container",
        dotsClass: "dot-container",
        navClass: ["arrow arrow-left", "arrow arrow-right"],
        navText: [
          '<i class="fa fa-chevron-left" ></i>',
          '<i class="fa fa-chevron-right"></i>'
        ],
        navElement: "div"
      });

      owl.on("changed.owl.carousel", function(event) {
        const { index } = event.item;
        self.page = index;
      });

      const count = this.filterRoster.length;
      if (count === 1) {
        $(".dot").hide();
      }
    },
    filterTitleArr() {
      const dutyArr = this.roster.map(item => item.actvType);
      this.titleArr = dutyArr.filter(
        actv => actv !== 5 && actv !== 6 && actv !== 7 && actv !== 8
      );
    },
    filterSubActv(subActv) {
      return subActv.filter(item => item.subActvName != "LO");
    },
    filterSubActvList(idx) {
      return this.filterRoster[idx].subActv.filter(
        item => item.subActvId === this.selectedDuty
      );
    },
    async changSelectedSubActv() {
      const currentActivity = this.filterRoster[this.page];
      const currentIndex = currentActivity.subActv.findIndex(
        obj => obj.isDefault === "1"
      );
      this.currentMission = currentActivity.subActv[currentIndex];
      this.selectedDuty = this.currentMission.subActvId;

      const { toAirp } = currentActivity.subActv[currentIndex];
      const bool = await this.checkHotelInfoSatus(toAirp);
      this.isHotelInfoValid = bool;
    },
    durationFormat(duration) {
      if (!duration) {
        return;
      }
      const durationLeft = duration.split(":")[0];
      const durationRight = duration.split(":")[1];
      if (duration.charAt(0) === "0" && duration.charAt(3) === "0") {
        return `${durationLeft.slice(1)} HR ${durationRight.slice(1)} MIN`;
      } else if (duration.charAt(0) === "0") {
        return `${durationLeft.slice(1)} HR ${durationRight} MIN`;
      } else if (duration.charAt(3) === "0") {
        return `${durationLeft} HR ${durationRight.slice(1)} MIN`;
      } else {
        return `${durationLeft} HR ${durationRight} MIN`;
      }
    },
    isAircReg(aircReg, position) {
      if (aircReg || position) return true;
      return false;
    },
    filterRemarks(remarks) {
      return remarks.replaceAll("\n", "<br />");
    },
    hidePopover() {
      document.getElementsByTagName("body")[0].addEventListener("click", e => {
        this.$root.$emit("bv::hide::popover");
      });
    }
  },
  computed: {
    ...mapGetters([
      "roster",
      "impersonateMail",
      "isPersonExist",
      "isReturnNoDuty"
    ]),
    showFooter() {
      this.actvType = this.titleArr[this.page];
      if (this.actvType === 0 || this.actvType === 3 || this.actvType === 9)
        return true;
      return false;
    },
    filterRoster() {
      return this.roster.filter(
        a =>
          a.actvType != 5 &&
          a.actvType != 6 &&
          a.actvType != 7 &&
          a.actvType != 8
      );
    },
    showDutyLen() {
      if (this.titleArr.includes(99)) return this.filterRoster.length - 1;
      return this.filterRoster.length;
    },
    showIcon() {
      switch (this.actvType) {
        case 0:
          return "fa fa-plane rotate";
        case 1:
          return "fa fa-mobile";
        case 2:
          return "fa fa-building";
        case 3:
          return "fa fa-book";
        case 4:
          return "fa fa-id-card";
        case 9:
          return "fa fa-book";
        default:
          return "";
      }
    },
    changeIconColor() {
      return { "text-primary": this.isRemark };
    },
    showDutyName() {
      switch (this.actvType) {
        case 0:
          return "Flight";
        case 1:
          return "Reserve/Standby";
        case 2:
          return "Ground";
        case 3:
          return "Ground Training";
        case 4:
          return "License Renewal";
        case 9:
          return "Ground Training";
        case 99:
          return "Congratulations 🎉";
        default:
          return "";
      }
    },
    originalMailOrNot() {
      if (this.impersonateMail != "") {
        return this.impersonateMail === localStorage.getItem("mail");
      } else {
        return true;
      }
    }
  },
  async created() {
    await this.getCrewRosterData();
    this.hidePopover();
  },
  watch: {
    impersonateMail(to) {
      this.getCrewRosterData(to);
      this.hidePopover();
      this.filterRoster.splice(0, this.filterRoster.length);
    },
    page(to) {
      this.changSelectedSubActv();
      this.$nextTick(() => {
        this.hidePopover();
      });
    },
    actvType(to) {
      let hbdArrow = document.querySelector(".arrow-right");
      let owlStageOuter = document.querySelector(".owl-stage-outer");
      if (to === undefined) {
        return;
      }
      if (to === 99) {
        hbdArrow.style.color = "#3D5F64";
        owlStageOuter.style.background = "rgba(102, 159, 166, 1)";
      } else {
        hbdArrow.style.color = "rgba(153, 153, 153, 1)";
        owlStageOuter.style.background = "white";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-dropdown {
  background-color: white;
  border-radius: 4px;
  select {
    cursor: pointer;
    color: rgba(51, 51, 51, 1);
    font-size: 2.5rem;
    font-weight: bold;
    padding: 8px 20px 8px 4px;
    border: none;
    background-color: white;
    appearance: none;
    background-image: url("/img/arrowDown.png");
    background-repeat: no-repeat;
    background-position: 100% 50%;
    background-size: 16px;
    text-align-last: center;
    text-align: center;
    -ms-text-align-last: center;
    -moz-text-align-last: center;
    font-family: Arial;

    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}

.carousel-tit {
  position: absolute;
  font-size: 1.8rem;
  top: 3%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
}

.nullHeight {
  height: 21px;
}

.rotate {
  transform: rotate(45deg);
}

i {
  font-size: 2rem;
  color: #96694c;
}

.empty-status .icon i {
  color: black;
}

button {
  border: none;
  background: transparent;
}

.icon-center {
  margin-bottom: 0.26rem;
}
.schedule-btn {
  font-weight: 500;
  color: darken(#96694c, 5%);
  &:hover,
  &:focus {
    color: darken(#96694c, 10%);
  }
}

//for happy birthday img setting
.home-demo {
  height: auto;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    min-height: 430px;
  }

  @media screen and (min-width: 768px) {
    height: 424px;
  }

  .wonderImg {
    z-index: 4;
    position: absolute;
    left: 42%;
    top: 25px;
    pointer-events: none;
    @media (max-width: 480px) {
      width: 70%;
      transform: translate(-41%, 70%);
    }
  }
  .starImg {
    z-index: 3;
    position: absolute;
    top: 38%;
    pointer-events: none;
  }
}

.icon-position {
  right: -40px;
  top: 15px;
}
.single-icon-position {
  right: -45px;
  top: -2px;
}

.card-footer {
  .btn {
    font-size: 1.8rem;
  }
}
</style>
